import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { KanbanChipBadgeComponent } from '../kanban-chip-badge/kanban-chip-badge.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { OrderHistoryItem } from '../../../interfaces/order-history-item';
import { PipesModule } from '@aionzdev/design-system';

@Component({
  selector: 'aionz-order-history-accordion',
  imports: [MatExpansionModule, MatDividerModule, KanbanChipBadgeComponent, MatIconModule, PipesModule],
  templateUrl: './order-history-accordion.component.html',
  styleUrl: './order-history-accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderHistoryAccordionComponent {
  public item = input.required<OrderHistoryItem>();

  public opened = signal<boolean>(false);
  public chipLabel = computed(() => `Cod. Pedido: ${this.item().orderCode}`);
  public productCount = computed(() => this.item().products.length);
}
